import { render, staticRenderFns } from "./SearchBoxItem.vue?vue&type=template&id=6d49e78a"
import script from "./SearchBoxItem.ts?vue&type=script&lang=ts&external"
export * from "./SearchBoxItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports